import { InstanceComponentBase } from '../../shared/instanceComponentBase';
import { AttributeEnums } from '../../shared/utilities/enums/attributeEnums';
import { HelperUtils } from '../../shared/utilities/helperUtils';


export class Countdown extends InstanceComponentBase {
  private expiryDate: Date = new Date(this.htmlElement.getAttribute(AttributeEnums.Countdown.CountdownExpires));
  private expiryDateDistance = this.expiryDate.getTime();

  private DaysElement: HTMLElement | null = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Countdown.CountdownDays));
  private HoursElement: HTMLElement | null = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Countdown.CountdownHours));
  private MinutesElement: HTMLElement | null = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Countdown.CountdownMinutes));
  private SecondsElement: HTMLElement | null = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Countdown.CountdownSeconds));

  constructor(public htmlElement: Element) {
    super(htmlElement);
    this.startCountdown();
  }

  startCountdown() {
    let countInterval;
    if (new Date().getTime() < this.expiryDateDistance) {
      countInterval = setInterval((): void => {
        this.updatePage();
      }, 1000);
    }
  }

  forceTwoCarecters(string: string) {
    if (string.length === 1) {
      string = "0" + string;
    }
    return string;
  }

  updatePage() {
    let now = new Date().getTime();
    let distance: number = this.expiryDateDistance - now;

    let days: string = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
    let hours: string = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
    let minutes: string = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
    let seconds: string = Math.floor((distance % (1000 * 60)) / 1000).toString();

    try {
      if(this.DaysElement !== null && this.HoursElement !== null && this.MinutesElement !== null && this.SecondsElement !== null){
        this.DaysElement.innerHTML = days;
        this.HoursElement.innerHTML = this.forceTwoCarecters(hours);
        this.MinutesElement.innerHTML = this.forceTwoCarecters(minutes);
        this.SecondsElement.innerHTML = this.forceTwoCarecters(seconds);
    
        if (distance < 0) {
          location.reload();
        }
      }

    } catch (error) {
      console.log(`Countdown: updatePage Error`);
    }
  }

  //------ Clean Up Processes Start -----//
  dispose(): void {
  }
  //------ Clean Up Processes End -----//
}